export async function spinning(scope, ctx) {
    const { hud, reels, gameLogic, data, audio } = ctx;

    hud.setSpinningState();
    hud.resetWin();
    hud.setBalance(gameLogic.balance - gameLogic.bet);
    // TODO: audio.playSfx("spin_start");

    const spinTimeline = reels.spin(data.spinType);
    scope.defer(() => { if (spinTimeline) spinTimeline.kill(); });

    let isSkipped = false;

    scope.on(hud.onStop, () => {
        if (spinTimeline && spinTimeline.isActive()) {
            spinTimeline.progress(1);
            isSkipped = true;
        }
    });

    const result = await gameLogic.spin();

    if (spinTimeline) {
        await new Promise((resolve) => {
            if (!spinTimeline.isActive()) return resolve();
            spinTimeline.eventCallback("onComplete", resolve);
        });
    }

    return { result, quickStop: isSkipped };
}
